<template>
  <div class="min-h-screen p-6 md:p-12 bg-gray-900 font-sans text-gray-300">
    <!-- Filters and sorting - not implemented yet, but for future use -->
    <div class="flex flex-col sm:flex-row items-center justify-between mb-8 space-y-4 sm:space-y-0">
      <div class="flex flex-wrap items-center space-x-4 sm:space-x-6">
        <button class="bg-gray-800 text-sm py-2 px-4 rounded-full hover:bg-gray-700 transition-colors duration-200">
          All genres
        </button>
        <button class="bg-gray-800 text-sm py-2 px-4 rounded-full hover:bg-gray-700 transition-colors duration-200">
          All the years
        </button>
      </div>
      <div class="flex items-center space-x-4">
        <span class="text-sm text-gray-400">Sort by:</span>
        <button class="text-sm font-semibold text-gray-100 border-b-2 border-red-500 pb-1">Featured</button>
        <button class="text-sm font-semibold hover:text-gray-100 transition-colors duration-200">Popular</button>
        <button class="text-sm font-semibold hover:text-gray-100 transition-colors duration-200">Newest</button>
      </div>
    </div>

    <!-- Movie Grid -->
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6">
      <!-- Loading State -->
      <div v-if="isLoading" class="text-center col-span-full py-20">Loading movies...</div>

      <!-- Error State -->
      <div v-else-if="error" class="text-center col-span-full py-20 text-red-400">Error: {{ error }}</div>

      <!-- Movie Cards -->
      <div
          v-else
          v-for="movie in movies"
          :key="movie.id"
          class="flex flex-col rounded-xl overflow-hidden shadow-lg transition-transform duration-300 hover:scale-105 bg-gray-800 cursor-pointer"
          @click="openMovieUrl(movie)"
      >
        <!-- Image Container -->
        <div class="relative w-full overflow-hidden" style="padding-top: 150%;">
          <img
              :src="getFullImageUrl(movie.imageurl)"
              :alt="movie.title"
              class="absolute top-0 left-0 w-full h-full object-cover rounded-t-xl"
              @error="onImageError"
          />
        </div>

        <!-- Movie Details -->
        <div class="p-4 flex flex-col items-center text-center">
          <h3 class="text-base font-semibold text-white mb-1 leading-tight">{{ movie.title }}</h3>
          <p class="text-xs text-gray-400 flex flex-wrap justify-center space-x-2">
            <span>{{ movie.genre }}</span>
            <span class="text-gray-600">•</span>
            <span>{{ movie.year }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MovieGallery',
  data() {
    return {
      movies: [],
      isLoading: true,
      error: null,
    };
  },
  methods: {
    getFullImageUrl(imagePath) {
      console.log('Fetching image for path:', imagePath);

      if (typeof imagePath !== 'string' || imagePath.trim() === '') {
        return '/images/default_movie.jpg';
      }
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
      }
      return `${imagePath}`;
    },
    onImageError(event) {
      event.target.src = '/images/default_movie.jpg';
      event.target.onerror = null;
    },
    async fetchMovies() {
      try {
        const response = await fetch('/api/movies');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        this.movies = await response.json();
      } catch (e) {
        this.error = e.message;
      } finally {
        this.isLoading = false;
      }
    },
    openMovieUrl(movie) {
      if (movie.url && typeof movie.url === 'string' && movie.url.trim() !== '') {
        // Ensure the URL starts with http or https
        const fullUrl = movie.url.startsWith('http')
            ? movie.url
            : `https://${movie.url}`;
        window.open(fullUrl, '_blank');
      } else {
        console.warn(`No valid URL found for movie: ${movie.title}`);
      }
    },
  },
  mounted() {
    this.fetchMovies();
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');
.font-sans {
  font-family: 'Inter', sans-serif;
}
</style>
